//
// TextTemplatesManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var TextTemplatesManager = createModule("transport::TextTemplatesManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        _getSummaryMessage_ss: [1,7,7],
        _getSummaryMessage_ob: [1,1,2],
    },
    ,
    ["getSummaryMessage"],
]);
export default TextTemplatesManager;
